import {HistoryStorageWithMaterial} from '@domain/material-storage'

// get result of the form [{measuredAt: '2020-02-20T10:10:10Z', storages: [{id: ..., }, {id: ..., }]}, ...] sorted by measuredAt
export const getStoragesGroupedByUpdate = (
  storages: HistoryStorageWithMaterial[]
): {measuredAt: string; storages: HistoryStorageWithMaterial[]}[] => {
  const tmp: {[id: string]: HistoryStorageWithMaterial[]} = {}

  for (const storage of storages) {
    if (!(storage.currentStorageLevel.measuredAt in tmp)) {
      tmp[storage.currentStorageLevel.measuredAt] = []
    }
    tmp[storage.currentStorageLevel.measuredAt].push(storage)
  }
  return Object.keys(tmp)
    .sort()
    .map((key) => ({
      measuredAt: key,
      storages: tmp[key].sort()
    }))
}
